module.exports = __webpack_public_path__ + "static/img/3.5e32b45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-de/3.jpg
// module id = amaT
// module chunks = 1